
import React, { useRef, useState } from 'react';
import { Avatar, ImageUploader, List, NavBar, TextArea } from 'antd-mobile'

import { 
    BodyView,
    ButtonView,
    InputView,
    ListView
} from "../factory/ViewUtil";

import { 
    AddOutline
} from 'antd-mobile-icons';
import { AlertContent, ToastContent, ToastLoading } from '../factory/FactoryUtil';
import { FeedbackResortMessage } from '../../NetworkFactory';

const FeedbackResortController = ({goback}) => {

    const [base64, seBase64] = useState('')
    const input = useRef(null)
    const openPhoto = () => {
        const nativeInput = input.current?.nativeElement
        if (nativeInput) {
            nativeInput.click()
        }
    };
    const handerPhoto = (file) => {
        return new Promise(() => {
            const reader = new FileReader();
            reader.onload = (e) => {
                seBase64(e.target.result);
            };
            reader.readAsDataURL(file);
        });
    };

    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')

    const postSubmit = () => {
        if(title.length <2 || title.length > 40) {
            AlertContent('Please enter title length limit [2-40]')
        }
        else if(message.length < 2 || message.length > 200) {
            AlertContent('Please message body length limit [2-200]')
        }
        else {

            // # 提交报告
            ToastLoading('Submitting...')
            let data = {
                title : title,
                message : message
            }

            if(base64.length > 10) {
                data['img'] = base64
            }
            FeedbackResortMessage(data).then(() => {
                ToastContent('Submitted Success')
                goback()
            }).catch(() => {
                ToastContent('Error')
            })
        }
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Edit Resort</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <List.Item style={{margin : '10px 0'}}>
                        <InputView placeholder='Enter title' value={title} onChange={(val) => {setTitle(val)}} />
                    </List.Item>

                    <List.Item style={{margin : '10px 0'}}>
                        <div className='inputViewWrapper'>
                            <TextArea maxLength={200} rows={4} showCount placeholder='Enter message body' value={message} onChange={(val) => {setMessage(val)}} />
                        </div>
                    </List.Item>

                    <List.Item style={{margin : '10px 0'}}>
                        <ImageUploader
                            ref={input}
                            accept = 'image/jpeg,image/jpg,image/png'
                            beforeUpload={handerPhoto}
                            maxCount={1} 
                            columns={0}
                            onPreview={false}
                            style={{display : 'none'}}
                        />
                        <div onClick={()=> {openPhoto()}} style={{width : '100px', height : '100px'}}>
                            <Avatar fallback={<div style={{height : '100px', fontSize : '50px', display : 'flex', justifyContent : 'center', alignItems : 'center', color : '#D8D8D8'}}><AddOutline/></div>} 
                            src={base64} 
                            style={{width : '100%', height : '100%', background : '#F6F6F6', borderRadius : '10px'}}/>
                        </div>
                    </List.Item>

                    <List.Item style={{margin : '10px 0'}}>
                        <ButtonView onClick={postSubmit}>Submit</ButtonView>
                    </List.Item>
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(FeedbackResortController)